import React, { useEffect, useState } from "react";
import { uploadImage, UploadFn } from "../../compliance/utils";
import {
  Content,
  DocumentWrapper,
  Label,
  Icon,
} from "./styles";
import { ProgressStatus } from "../../../pages/Wallets/utils";

interface UploadProps {
  type: "INITIAL" | "LOADING" | "APPROVED" | "UPLOADED" | "PENDING" | "FAILED";
  documentTitle?: string;
  documentSubtitle?: string;
  docId?: number;
  upload?: UploadFn;
  onUpload?: (newDoc: any) => void; 
  imageId?: string;
  onShowAlert?: (title: string, description?: string) => void;
}

const DocumentUpload = ({
  type = "INITIAL",
  documentTitle,
  documentSubtitle,
  docId,
  upload,
  onUpload,
  imageId,
  onShowAlert,
}: UploadProps) => {
  const [uploadingProgress, setUploadingProgress] =
    useState(0);
  const [documentExistStatus, setDocumentExistStatus] =
    useState("idle");
  const [fileType, setFileType] = useState("");
  const [fileName, setFileName] = useState("");
  const [uploadingStatus, setUploadingStatus] =
    useState<ProgressStatus>("idle");

  function convertToSentenceCase(inputString) {
    if (
      typeof inputString !== "string" ||
      inputString.length === 0
    ) {
      return inputString;
    }

    if (inputString === "FAILED") {
      return "Rejected";
    }

    const lowerCaseString = inputString.toLowerCase();
    const sentenceCaseString =
      lowerCaseString.charAt(0).toUpperCase() +
      lowerCaseString.slice(1);

    return sentenceCaseString;
  }
  
  useEffect(() => {
    setUploadingStatus("idle");
  }, []);

  const onUploadDocument = (file: File | null) => {
    if (file && upload) {
      setUploadingStatus("progress");
      const docName = file.name;
        uploadImage({
        file,
        docName,
        upload,
        setUploadingProgress,
        setFileType,
        setDocumentExistStatus,
        setUploadingStatus,
        setFileName,
        onFinish: () => {
         
          const newDocDetail = {
            id: docId,
            fileName: fileName,
            fileType: fileType,
            uploadStatus: uploadingStatus,
            uploadProgress: uploadingProgress,
            docExistsStatus: documentExistStatus,
            imageId,
          };
  
          onUpload && onUpload(newDocDetail);
        },
        onShowAlert,
      });
    }
  };
  

  

  useEffect(() => {
    if (["APPROVED", "FAILED", "PENDING"].includes(type)) {
      setUploadingStatus("done");
    }
  }, [type]);

  return (
    <Label>
      <Content status={type}>
        <Icon iconType={type} />
        <div>
          <h3>
            {uploadingStatus === "progress"
  ? "Compressing..."
  : documentTitle
  ? documentTitle
  : uploadingStatus === "done"
  ? fileName
  : "Upload file"}


          </h3>
          <p>
            {uploadingStatus === "done"
              ? convertToSentenceCase(type)
              : type === "LOADING"
              ? "Please wait..."
              : documentSubtitle
              ? documentSubtitle
              : documentTitle
              ? documentTitle
              : "PDF, JPEG or PNG less than 5MB"}
          </p>
        </div>
      </Content>
      <DocumentWrapper
        type="file"
        accept=".pdf, .jpg, .png"
        onChange={(event) =>
          onUploadDocument(event.target.files?.[0])
        }
        disabled={type !== "INITIAL"}
      />
    </Label>
  );
};

export default DocumentUpload;
